import { BaseButton, BaseButtonProps } from './../base';
import { XMarkIcon } from './xMark';

interface CloseButtonProps extends Partial<BaseButtonProps> {
  icon?: React.ElementType;
}

export const CloseButton = ({
  onClick,
  className = '',
  icon: Icon = XMarkIcon,
  ...props
}: CloseButtonProps) => {
  return (
    <BaseButton
      variant="ghost"
      size="md"
      onClick={onClick}
      className={`!p-1 rounded-full ${className}`}
      aria-label="Close"
      {...props}
    >
      <Icon className="w-5 h-5 transition-transform hover:rotate-90" />
    </BaseButton>
  );
};
